export default __webpack_public_path__ + "static/media/MeMoji.203614a4.webp";